var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function List2IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 7.99703V16.003C21 16.5536 20.5551 17 20.0001 17H3.99985C3.44765 17 3 16.5527 3 16.003V7.99703C3 7.44639 3.44495 7 3.99985 7H20.0001C20.5524 7 21 7.44726 21 7.99703ZM3 4C3 3.44772 3.44495 3 3.99985 3H20.0001C20.5524 3 21 3.44386 21 4C21 4.55228 20.5551 5 20.0001 5H3.99985C3.44765 5 3 4.55614 3 4ZM3 20C3 19.4477 3.44495 19 3.99985 19H20.0001C20.5524 19 21 19.4439 21 20C21 20.5523 20.5551 21 20.0001 21H3.99985C3.44765 21 3 20.5561 3 20ZM19 15V9H5V15H19Z", fill: "" })));
}
export var List2Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: List2IconInner }, props))); };
//# sourceMappingURL=List2Icon.js.map